import { Controller } from "@hotwired/stimulus"
import { reactor } from "../lib/reactor"

export default class extends Controller {
  static targets = ["template"]

  connect() {
    reactor(this)
    this.resizeObserver = new ResizeObserver(() => this.fill())
    this.resizeObserver.observe(this.element)
    this.fill()
  }

  disconnect() {
    this.resizeObserver?.disconnect()
  }

  morph() {
    this.fill()
  }

  fill() {
    if (!this.hasTemplateTarget || this.filling) return
    if (this.element.clientHeight === 0) return

    this.filling = true
    try {
      this.clear()

      while (true) {
        const row = this.appendRow()
        if (!row || row.offsetHeight === 0 || this.element.scrollHeight > this.element.clientHeight) {
          row?.remove()
          break
        }
      }

      this.notifyScrollFade()
    } finally {
      this.filling = false
    }
  }

  clear() {
    this.element
      .querySelectorAll("[data-activity-skeleton-row]")
      .forEach((el) => el.remove())
  }

  appendRow() {
    const root = this.templateTarget.content.firstElementChild
    if (!root) return null

    const row = root.cloneNode(true)
    row.setAttribute("data-activity-skeleton-row", "")
    row.setAttribute("aria-hidden", "true")
    this.element.insertBefore(row, this.templateTarget) // before template so the timeline skips the inert node
    return row
  }

  notifyScrollFade() {
    const host = this.element.closest("[data-controller~='scroll-fade']")
    if (!host) return

    const scrollFade = this.application.getControllerForElementAndIdentifier(
      host,
      "scroll-fade"
    )
    scrollFade?.check()
  }
}
